module.exports = __webpack_public_path__ + "img/host1-sm.01c859c6.png";